/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ items: NonNullable<unknown> }} Searchreadymissing2Inputs */

const en_searchreadymissing2 = /** @type {(inputs: Searchreadymissing2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Missing: ${i?.items}.`)
};

const de_searchreadymissing2 = /** @type {(inputs: Searchreadymissing2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlt: ${i?.items}.`)
};

/**
* | output |
* | --- |
* | "Missing: {items}." |
*
* @param {Searchreadymissing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadymissing2 = /** @type {((inputs: Searchreadymissing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadymissing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadymissing2(inputs)
	return de_searchreadymissing2(inputs)
});
export { searchreadymissing2 as "searchReadyMissing" }